import { render, staticRenderFns } from "./TierForm.vue?vue&type=template&id=27bdb69e&scoped=true&"
import script from "./TierForm.vue?vue&type=script&lang=js&"
export * from "./TierForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bdb69e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27bdb69e')) {
      api.createRecord('27bdb69e', component.options)
    } else {
      api.reload('27bdb69e', component.options)
    }
    module.hot.accept("./TierForm.vue?vue&type=template&id=27bdb69e&scoped=true&", function () {
      api.rerender('27bdb69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Agent/components/Tier/TierForm.vue"
export default component.exports